<script>
export default {
  methods: {
    async defaultOwnAirport () {
      var defaultAP = ''
      defaultAP = this.fromSession_OwnAirport()

      if (defaultAP === '') {
        defaultAP = await this.fromRDS_OwnAirport()
      }
      return defaultAP
    },
    fromSession_OwnAirport () {
      var defaultAP = this.getDefaultOwnAirport()
      return defaultAP
    },
    async fromRDS_OwnAirport () {
      var defaultAP = ''
      await this.$axios
        // .get('/code-master/own-airport', { params: {} })
        .get('/code-master', { params: { code_id: 'OWN_AIRPORT_CODE' } })
        .then((res) => {
          if (res.data.list.length > 0) {
            // defaultAP = res.data.list[0].own_airport
            defaultAP = res.data.list[0].code_value
          }
        })
        .catch((e) => {
          console.log(e)
        })
      return defaultAP
    },
    getDefaultOwnAirport () {
      var defaultAP = ''
      if (this.$session.get('ownAirport') !== undefined) {
        if (this.$session.get('ownAirport') !== '') {
          defaultAP = this.$session.get('ownAirport')
        }
      }
      return defaultAP
    }
  }
}
</script>
